import { render, staticRenderFns } from "./ObjectifConnectSend.vue?vue&type=template&id=a0cb6d4e&scoped=true&"
import script from "./ObjectifConnectSend.vue?vue&type=script&lang=js&"
export * from "./ObjectifConnectSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cb6d4e",
  null
  
)

export default component.exports